import { render, staticRenderFns } from "./rangliste_footer.vue?vue&type=template&id=432c1a9e"
import script from "./rangliste_footer.vue?vue&type=script&lang=js"
export * from "./rangliste_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports